var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBlur2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "blur",
    xmlns: "http://www.w3.org/2000/svg",
    width: 32.86,
    height: 32.86,
    viewBox: "0 0 32.86 32.86",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_61",
    "data-name": "Groupe 61"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_60",
    "data-name": "Groupe 60"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_42",
    "data-name": "Trac\\xE9 42",
    d: "M.865,234.667a.865.865,0,1,0,.865.865A.867.867,0,0,0,.865,234.667Z",
    transform: "translate(0 -215.643)",
    fill: "#707070"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_43",
    "data-name": "Trac\\xE9 43",
    d: "M.865,149.333a.865.865,0,1,0,.865.865A.867.867,0,0,0,.865,149.333Z",
    transform: "translate(0 -137.227)",
    fill: "#707070"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_44",
    "data-name": "Trac\\xE9 44",
    d: "M150.2,384a.865.865,0,1,0,.865.865A.867.867,0,0,0,150.2,384Z",
    transform: "translate(-137.227 -352.869)",
    fill: "#707070"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_45",
    "data-name": "Trac\\xE9 45",
    d: "M55.063,53.333a1.73,1.73,0,1,0,1.729,1.73A1.735,1.735,0,0,0,55.063,53.333Z",
    transform: "translate(-49.01 -49.009)",
    fill: "#707070"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_46",
    "data-name": "Trac\\xE9 46",
    d: "M55.063,138.667a1.729,1.729,0,1,0,1.729,1.729A1.735,1.735,0,0,0,55.063,138.667Z",
    transform: "translate(-49.01 -127.425)",
    fill: "#707070"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_47",
    "data-name": "Trac\\xE9 47",
    d: "M55.063,224a1.729,1.729,0,1,0,1.729,1.729A1.735,1.735,0,0,0,55.063,224Z",
    transform: "translate(-49.01 -205.84)",
    fill: "#707070"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_48",
    "data-name": "Trac\\xE9 48",
    d: "M384.865,151.063A.865.865,0,1,0,384,150.2.867.867,0,0,0,384.865,151.063Z",
    transform: "translate(-352.869 -137.227)",
    fill: "#707070"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_49",
    "data-name": "Trac\\xE9 49",
    d: "M235.531,1.729a.865.865,0,1,0-.865-.865A.867.867,0,0,0,235.531,1.729Z",
    transform: "translate(-215.642 0)",
    fill: "#707070"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_50",
    "data-name": "Trac\\xE9 50",
    d: "M140.4,56.793a1.729,1.729,0,1,0-1.729-1.729A1.735,1.735,0,0,0,140.4,56.793Z",
    transform: "translate(-127.425 -49.01)",
    fill: "#707070"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_51",
    "data-name": "Trac\\xE9 51",
    d: "M150.2,1.729a.865.865,0,1,0-.865-.865A.867.867,0,0,0,150.2,1.729Z",
    transform: "translate(-137.227 0)",
    fill: "#707070"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_52",
    "data-name": "Trac\\xE9 52",
    d: "M225.729,56.793A1.729,1.729,0,1,0,224,55.063,1.735,1.735,0,0,0,225.729,56.793Z",
    transform: "translate(-205.84 -49.01)",
    fill: "#707070"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_53",
    "data-name": "Trac\\xE9 53",
    d: "M55.063,309.333a1.729,1.729,0,1,0,1.729,1.73A1.735,1.735,0,0,0,55.063,309.333Z",
    transform: "translate(-49.01 -284.255)",
    fill: "#707070"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_54",
    "data-name": "Trac\\xE9 54",
    d: "M215.927,128a2.594,2.594,0,1,0,2.594,2.594A2.591,2.591,0,0,0,215.927,128Z",
    transform: "translate(-196.038 -117.623)",
    fill: "#707070"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_55",
    "data-name": "Trac\\xE9 55",
    d: "M311.063,224a1.729,1.729,0,1,0,1.729,1.729A1.735,1.735,0,0,0,311.063,224Z",
    transform: "translate(-284.256 -205.84)",
    fill: "#707070"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_56",
    "data-name": "Trac\\xE9 56",
    d: "M311.063,309.333a1.729,1.729,0,1,0,1.729,1.73A1.735,1.735,0,0,0,311.063,309.333Z",
    transform: "translate(-284.256 -284.255)",
    fill: "#707070"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_57",
    "data-name": "Trac\\xE9 57",
    d: "M311.063,138.667a1.729,1.729,0,1,0,1.729,1.729A1.735,1.735,0,0,0,311.063,138.667Z",
    transform: "translate(-284.256 -127.425)",
    fill: "#707070"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_58",
    "data-name": "Trac\\xE9 58",
    d: "M384.865,234.667a.865.865,0,1,0,.865.865A.867.867,0,0,0,384.865,234.667Z",
    transform: "translate(-352.869 -215.643)",
    fill: "#707070"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_59",
    "data-name": "Trac\\xE9 59",
    d: "M311.063,53.333a1.73,1.73,0,1,0,1.729,1.73A1.735,1.735,0,0,0,311.063,53.333Z",
    transform: "translate(-284.256 -49.009)",
    fill: "#707070"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_60",
    "data-name": "Trac\\xE9 60",
    d: "M130.594,213.333a2.594,2.594,0,1,0,2.594,2.594A2.591,2.591,0,0,0,130.594,213.333Z",
    transform: "translate(-117.623 -196.038)",
    fill: "#707070"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_61",
    "data-name": "Trac\\xE9 61",
    d: "M140.4,309.333a1.729,1.729,0,1,0,1.729,1.729A1.735,1.735,0,0,0,140.4,309.333Z",
    transform: "translate(-127.425 -284.255)",
    fill: "#707070"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_62",
    "data-name": "Trac\\xE9 62",
    d: "M130.594,128a2.594,2.594,0,1,0,2.594,2.594A2.591,2.591,0,0,0,130.594,128Z",
    transform: "translate(-117.623 -117.623)",
    fill: "#707070"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_63",
    "data-name": "Trac\\xE9 63",
    d: "M225.729,309.333a1.73,1.73,0,1,0,1.729,1.73A1.735,1.735,0,0,0,225.729,309.333Z",
    transform: "translate(-205.84 -284.255)",
    fill: "#707070"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_64",
    "data-name": "Trac\\xE9 64",
    d: "M235.531,384a.865.865,0,1,0,.865.865A.867.867,0,0,0,235.531,384Z",
    transform: "translate(-215.642 -352.869)",
    fill: "#707070"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_65",
    "data-name": "Trac\\xE9 65",
    d: "M215.927,213.333a2.594,2.594,0,1,0,2.594,2.594A2.591,2.591,0,0,0,215.927,213.333Z",
    transform: "translate(-196.038 -196.038)",
    fill: "#707070"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlur2);
export default __webpack_public_path__ + "static/media/blur2.9a9b02d4da109398892999ad4d409309.svg";
export { ForwardRef as ReactComponent };